import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from '@app/services/notification.service';
import { Apollo } from 'apollo-angular';
import { CambiarClaveGQL } from '@app/services/cambiar-clave.mutation';

@Component({
  selector: 'app-cambiar-clave',
  templateUrl: './cambiar-clave.component.html',
  styleUrls: ['./cambiar-clave.component.css']
})
export class CambiarClaveComponent implements OnInit {
  changePasswordForm: FormGroup;
  pwdPattern = '^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Z]{6,}$';
  email = '';

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<CambiarClaveComponent >,
    private notificationService: NotificationService,
    private cambiaClaveGQL: CambiarClaveGQL,
    @Inject(MAT_DIALOG_DATA) public data: any, private apollo: Apollo) { 

      this.changePasswordForm = fb.group({
        'old_password': [null, Validators.required],
        'new_password': [null, [Validators.required, Validators.pattern(this.pwdPattern)]],
        'confirm_new_password': [null, [Validators.required, this.passwordMatch]]
    });

    }


  ngOnInit(): void {
    this.email = this.data.email;
  }

  passwordMatch(control: AbstractControl){
    let paswd = control.root.get('new_password');
    if(paswd && control.value != paswd.value){
     return {
         passwordMatch: false
     };   
    }
    return null;
}

changePassword(value){
  console.log(this.email);
  console.log(value);
    if(this.changePasswordForm.valid){
        console.log("Change password form valid");
        this.cambiaClaveGQL
        .mutate({
          email: this.email,
          clave: value.old_password,
          claveN: value.new_password,
        })
        .subscribe( ({ data }: any) => {
          this.notificationService.showNotification('Datos Validos', 'Resultado del Proceso:' + data.cambiarClaveUsuario.message, 'success');
         //this.router.navigate(['/usuario-perfil']);
        },
        (errors) => {
          this.notificationService.showNotification('Datos invalidos', 'Datos invalidos' + errors, 'warning');
        }
      )

    }
    this.dialogRef.close();
}
}
